import { FeatureChangeAction } from './types';
var AppStateManager = /** @class */ (function () {
    function AppStateManager(_featureAppId, _globalStateManager, _logger) {
        this._featureAppId = _featureAppId;
        this._globalStateManager = _globalStateManager;
        this._logger = _logger;
        // do nothing
    }
    /**
     * Should redirect to the correct carline if the loaded carline is different then current one
     *
     * @param audiCode
     */
    AppStateManager.prototype.loadAudiCode = function (audiCode) {
        this._logDebug('load audiCode', audiCode);
        this._globalStateManager.loadAudiCode(audiCode);
    };
    /**
     * Should redirect to the correct carline if the loaded carline is different then current one
     *
     * @param prString
     */
    AppStateManager.prototype.loadPrString = function (prString) {
        this._logDebug('load prString', prString);
        this._globalStateManager.loadPrString(prString);
    };
    /**
     * Select a new equipment option. Will trigger a new oneGraph request
     *
     * @param equipmentId PR3 or PR7
     */
    AppStateManager.prototype.addEquipment = function (equipmentId) {
        this._logDebug('Add equipment', equipmentId);
        this._globalStateManager.changeEquipment(equipmentId, FeatureChangeAction.Add);
    };
    /**
     * Deselect a new equipment option. Will rigger a new oneGraph request
     *
     * @param equipmentId PR3 or PR7
     */
    AppStateManager.prototype.removeEquipment = function (equipmentId) {
        this._logDebug('Remove equipment', equipmentId);
        this._globalStateManager.changeEquipment(equipmentId, FeatureChangeAction.Remove);
    };
    /**
     * With that method the current model can be changed.
     * This is usefull fo example if the user wants to change the selected engine
     *
     * @param modelId
     */
    AppStateManager.prototype.changeModel = function (modelId) {
        this._logDebug('Change model', modelId);
        this._globalStateManager.changeModel(modelId);
    };
    /**
     * With that method the current trimline can be changed.
     * This is usefull fo example if the user wants to change the selected trimline
     *
     * @param trimline
     */
    AppStateManager.prototype.changeTrimline = function (trimline) {
        this._logDebug('Change trimline', trimline);
        this._globalStateManager.changeTrimline(trimline);
    };
    /**
     * @param financalParameters
     */
    AppStateManager.prototype.changeFinancialParameters = function (financalParameters) {
        this._logDebug('Change financial parameters');
        this._globalStateManager.changeFinancialParameters(financalParameters);
    };
    /**
     * With this a app can subscribe to data chanege events and tell the state-manager
     * what ConfiguredCar fields are requested. The FeatureAppId is automaticaly
     * set internaly. Will return a unsubscribe function.
     *
     * @param handler
     * @param configuredCarFields
     * @return unsubscribe function
     */
    AppStateManager.prototype.subscribe = function (handler, configuredCarFields, variables, configuredCarFieldsForUpdate) {
        var _this = this;
        this._logDebug('Subscribe to StateManager', configuredCarFields, configuredCarFieldsForUpdate);
        this._globalStateManager.subscribe(this._featureAppId, function (event, queryVariables, configuredCarData) {
            handler(event, queryVariables, configuredCarData);
            if (configuredCarData) {
                _this._configuredCarData = configuredCarData;
            }
        }, configuredCarFields, variables, configuredCarFieldsForUpdate);
        return function () {
            _this.unsubscribe();
        };
    };
    AppStateManager.prototype.getConfiguredCarData = function () {
        return this._configuredCarData;
    };
    AppStateManager.prototype.unsubscribe = function () {
        this._logDebug('Unsubscribe from StateManager');
        this._globalStateManager.unsubscribe(this._featureAppId);
    };
    /**
     * Return the carIdentifier used for queries. This is only available after
     * the state-manager has done a single query. Or potentialy after a car was loaded
     * via prString or AudiCode
     *
     * @returns
     */
    AppStateManager.prototype.getCarId = function () {
        return this._globalStateManager.getCarId();
    };
    /**
     * Return the carlineInput data used in the query.
     * This depends on the carlineId set during the service setup and is
     * controleld by the integrator.
     * The country and language come from the locale service.
     *
     * @returns
     */
    AppStateManager.prototype.getCarlineInput = function () {
        return this._globalStateManager.getCarlineInput();
    };
    /**
     * The fincancingInput data, if available, that will be used in the query
     *
     * @returns
     */
    AppStateManager.prototype.getFinancingInput = function () {
        return this._globalStateManager.getFinancingInput();
    };
    /**
     * The WebcalcDomain, if available
     *
     * @returns
     */
    AppStateManager.prototype.getWebCalcDomain = function () {
        return this._globalStateManager.getWebCalcDomain();
    };
    /**
     * Show if currently the debug mode is activated. Apps can use this to display extra data etc.
     * This is set during the definition of the service in the inegrator
     *
     * @returns
     */
    AppStateManager.prototype.isDebug = function () {
        return this._globalStateManager.isDebug();
    };
    /**
     * Log debug message, if debug mode is enabled and logger service is available
     *
     * @param message
     * @param data
     */
    AppStateManager.prototype._logDebug = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this._logger && this.isDebug()) {
            this._logger.debug("AppStateManager for \"".concat(this._featureAppId, "\": ").concat(message), data);
        }
    };
    AppStateManager.prototype.isSubscribed = function () {
        return this._globalStateManager.isSubscribed(this._featureAppId);
    };
    return AppStateManager;
}());
export { AppStateManager };
//# sourceMappingURL=app-state-manager.js.map